import { Col, Container, Row } from "reactstrap";
import Description from "./Description";
import { FaBookAtlas } from "react-icons/fa6";
import { FaGlobeAsia } from "react-icons/fa";
import { MdWork } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";

const Why = () => {

  const listWhy = [
    { icon:<FaBookAtlas className="why-icon" />, title: "Swiss Vibe & Skill Praktis yang Siap Kerja", body: "BHMS combine akademik + praktik langsung selama kuliah — termasuk sistem dualisme: 6 bulan kuliah + 6 bulan magang dibayar setiap periode."},
    { icon:<FaGlobeAsia className="why-icon" />, title: "Lingkungan Internasional", body: "Kamu akan belajar bareng siswa dari seluruh dunia, memperluas networking global — bukan sekadar teori tapi interaksi budaya yang memperkaya pengalaman."},
    { icon:<MdWork className="why-icon" />, title: "Magang Terjamin & Karier Global", body: "Programnya guaranteed internships yang membantu kamu punya pengalaman kerja nyata di hotel, restoran, event, dan bisnis internasional."},
    { icon:<FaLocationDot className="why-icon" />, title: "Lokasi Hidup & Belajar di Swiss", body: "Belajar di kota iconic seperti Lucerne & (baru) Zurich — aman, bersih, serba modern, plus kesempatan eksplor budaya Eropa."},
  ]

  return (
    <section className="section" id="why">
      <Container>
        <Row className="why-wrapper flex-lg-row gap-4">
        <Description />
          <Col>
            <img 
              src="assets/images/img-why.webp" 
              alt="melbourne-polytechnic-sign-and-students-of-melbourne-polytechnic's" 
              className="img-fluid"
            />          
          </Col>
          <Col>
            <h1 className="mb-3"><b>4 Keunggulan Kampus BHMS</b></h1>
            <div className="mb-3 mb-md-5">
              {listWhy.map((item, id) => (
                <div key={id} className="d-flex text-start gap-2">
                  <div>
                    {item.icon}         
                  </div>
                  <div>
                      <span className="fw-bold">{item.title}</span>
                      <p className="fw-normal">{item.body}</p>
                  </div>                
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>      
    </section>
  );
};

export default Why;